import { create } from 'zustand';

interface SuccessModalProps {
  message: string;
  title?: string;
  details?: string[];
}

interface ErrorModalProps {
  message: string;
  title?: string;
}

interface ConfirmModalProps {
  message: string;
  onConfirm: () => void;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

interface ModalStore {
  isOpen: boolean;
  type: 'success' | 'error' | 'confirm' | null;
  props: SuccessModalProps | ErrorModalProps | ConfirmModalProps | null;
  
  showSuccessModal: (message: string, title?: string, details?: string[]) => void;
  showErrorModal: (message: string, title?: string) => void;
  showConfirmModal: (
    message: string,
    onConfirm: () => void,
    title?: string,
    confirmLabel?: string,
    cancelLabel?: string
  ) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  isOpen: false,
  type: null,
  props: null,

  showSuccessModal: (message: string, title?: string, details?: string[]) => {
    set({
      isOpen: true,
      type: 'success',
      props: { message, title, details },
    });
  },

  showErrorModal: (message: string, title?: string) => {
    set({
      isOpen: true,
      type: 'error',
      props: { message, title },
    });
  },

  showConfirmModal: (
    message: string,
    onConfirm: () => void,
    title?: string,
    confirmLabel?: string,
    cancelLabel?: string
  ) => {
    set({
      isOpen: true,
      type: 'confirm',
      props: { message, onConfirm, title, confirmLabel, cancelLabel },
    });
  },

  closeModal: () => {
    set({
      isOpen: false,
      type: null,
      props: null,
    });
  },
}));
